import React from "react";
import styled from "styled-components";
import { H5 } from "storybook-components/Typography";
import BlogArticleLink from "../BlogArticleLink";
import SmallCategoryLabel from "./SmallCategoryLabel";
import DateAndReadTime from "./PublishDate";
import PostRowCard from "./PostRowCard";
import IsRichTextValidator from "../Helpers/IsRichTextValidator";

const PreviewWrapper = styled(BlogArticleLink)`
  display: block;
  width: 100%;
  height: 240px;
  margin: auto;
  padding: 0;
  border-radius: 10px;
  text-decoration: none;
  color: unset;
`;

const PostTitle = styled(H5)`
  margin: 16px 0 24px;
  text-decoration: none;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.green5};
  ${props => props.theme.media.desktopUp`
    margin: 0 0 24px;
    height: 100px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  `};
`;

const PaddedCopyWrapper = styled.div`
  padding: 32px 24px;
`;

export default ({ node }) => {
  const isRichText = IsRichTextValidator(node.richTextBody);
  return (
    <PostRowCard>
      <PreviewWrapper to={node.slug}>
        <PaddedCopyWrapper>
          <SmallCategoryLabel category={node.categories} />
          <PostTitle className="text">{node.title}</PostTitle>
          <DateAndReadTime
            publishDate={node.publishDate}
            readTime={!isRichText && node.body.childMarkdownRemark.timeToRead}
            richTextData={node.richTextBody}
            marginTop="0"
          />
        </PaddedCopyWrapper>
      </PreviewWrapper>
    </PostRowCard>
  );
};
